import { P } from '@modul-connect/shared/components/atoms/text'
import theme from '@modul-connect/shared/theme'
import View from '@modul-connect/shared/components/atoms/view'
import ErrorIcon from '@mui/icons-material/Error'

export const ModalAlertBanner = ({ text }) => {
  return(
    <View style={{ backgroundColor: theme.colors.lightRed,  minHeight: 50,
      borderRadius: 4,
      alignItems: 'flex-start', 
      justifyContent: 'space-between',
      marginTop: 20,
      padding: 10 }}>
      <View style={{ display: 'flex', marginTop: 4, flexDirection: 'row', alignItems: 'flex-start', gap: 10 , flex: 1 }}>
        <ErrorIcon  sx={{ fontSize: 16, color: theme.colors.darkRed }} />
        <P noPadding extend={{ fontSize: 12, color: theme.colors.darkRed }}>{text}</P>
      </View>
    </View>
  )
}